<template>
  <div>
    <MainNav />
    <main class="container py-4">
      <div class="mb-4">
        <h1 class="h3 mb-1">Rapprochement du cash B2C</h1>
        <p class="text-muted mb-0">Situation complète du cash (nouveau calcul, source : grand livre). Réservé au fondateur.</p>
      </div>
      <div class="alert alert-warning py-2">
        Ce tableau remplace l'ancien écran comptable. L'ancien reste visible pendant la bascule, mais son total était erroné.
      </div>

      <div v-if="loading" class="alert alert-secondary">Chargement…</div>
      <div v-else-if="forbidden" class="alert alert-danger">Réservé au fondateur.</div>
      <div v-else-if="error" class="alert alert-danger">{{ error }}</div>

      <template v-else>
        <div class="row g-3 mb-4">
          <div class="col-6 col-md-3"><div class="card text-center shadow-sm"><div class="card-body">
            <div class="text-muted small">Chez les relais</div><div class="h4 mb-0">{{ euro(d.cash_at_relays) }}</div>
          </div></div></div>
          <div class="col-6 col-md-3"><div class="card text-center shadow-sm"><div class="card-body">
            <div class="text-muted small">Chez les collecteurs</div><div class="h4 mb-0">{{ euro(d.cash_at_collectors) }}</div>
          </div></div></div>
          <div class="col-6 col-md-3"><div class="card text-center shadow-sm border-primary"><div class="card-body">
            <div class="text-muted small">En circulation</div><div class="h4 mb-0">{{ euro(d.in_circulation) }}</div>
          </div></div></div>
          <div class="col-6 col-md-3"><div class="card text-center shadow-sm"><div class="card-body">
            <div class="text-muted small">En litige (gelé)</div><div class="h4 mb-0 text-danger">{{ euro(d.litigation_total) }}</div>
          </div></div></div>
        </div>

        <div class="row g-3">
          <div class="col-md-6"><div class="card shadow-sm"><div class="card-body">
            <div class="d-flex justify-content-between"><span>Écarts ouverts</span>
              <strong :class="{ 'text-danger': d.open_discrepancies > 0 }">{{ d.open_discrepancies }}</strong></div>
            <div class="d-flex justify-content-between"><span>Reçu au bureau</span><strong>{{ euro(d.cash_at_office) }}</strong></div>
          </div></div></div>
          <div class="col-md-6"><div class="card shadow-sm"><div class="card-body">
            <h2 class="h6">Relais proches du plafond</h2>
            <div v-if="d.relays_near_ceiling.length === 0" class="text-muted small">Aucun.</div>
            <ul v-else class="list-unstyled mb-0">
              <li v-for="r in d.relays_near_ceiling" :key="r.service_point_id" class="d-flex justify-content-between">
                <span :class="{ 'text-danger': r.over }">{{ r.name }}</span>
                <span>{{ euro(r.held) }} / {{ euro(r.limit_cash) }}</span>
              </li>
            </ul>
          </div></div></div>
        </div>
      </template>
    </main>
  </div>
</template>

<script>
import axios from 'axios'
import MainNav from '@/components/MainNav.vue'
export default {
  name: 'OfficeDashboard',
  components: { MainNav },
  data() { return { loading: true, forbidden: false, error: '',
    d: { cash_at_relays: '0', cash_at_collectors: '0', cash_at_office: '0', in_circulation: '0',
         litigation_total: '0', open_discrepancies: 0, relays_near_ceiling: [] } } },
  mounted() { this.load() },
  methods: {
    euro(v) { return `${Number(v).toFixed(2)} €` },
    async load() {
      this.loading = true; this.error = ''; this.forbidden = false
      try { const { data } = await axios.get('/api/v1/admin/cash-office-dashboard/'); this.d = data }
      catch (e) { if (e.response?.status === 403) this.forbidden = true; else this.error = "Chargement impossible." }
      finally { this.loading = false }
    },
  },
}
</script>
